import apiFetch from '../apiFetch'

export default function (token, finderParams) {
  return apiFetch({
    endPoint: 'AuditConfiguration/SearchDocuments',
    method: 'POST',
    body: finderParams,
    token: token
  })
}
